import React, { Component } from "react";
import "./RaiseTicketPage.scss";

interface RaiseTicketPageProps {}

interface RaiseTicketPageState {}

class RaiseTicketPage extends Component<RaiseTicketPageProps, RaiseTicketPageState> {
  constructor(props: RaiseTicketPageProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="raise-ticket-page">
        <header className="raise-ticket-page-header">
          <h1 className="raise-ticket-page-title">Raise a ticket</h1>
          <p className="raise-ticket-page-subtitle">
            Support flow placeholder. Replace with real ticketing before launch.
          </p>
        </header>
      </div>
    );
  }
}

export default RaiseTicketPage;
